import { AiTwotoneExperiment } from "react-icons/ai"
import { GiSpartanHelmet } from "react-icons/gi"
import { IconContext } from "react-icons";
import s from "./builder.module.css"
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useState } from "react";
import shadowImg from "../../../assets/a.jpg"
import { builderImage } from "../../../helper/helper";


export default function Builder({colorFondo}) {
    const [open, setOpen] = useState(false)
    let builderImagen = builderImage(colorFondo)
    return (
        <section className={s.section}>
            <div className={s.contenedor}>
                <span className={s.title}>Build a Soldier</span>
                <div className={s.secondContainer}>
                    <div className={s.gifContainer}><img className={s.gif} src={builderImagen} alt="gif" /></div>
                    <div className={s.textContainer}>
                        <div className={s.textContainer_container}>
                            <p>Create a custom Soldier and use it as your PFP.</p>
                            <p>Join the Army.</p>
                            <div className={s[colorFondo]}>
                                <IconContext.Provider value={{ className: "logo", size: "1.5em" }}>
                                    {/* <div><AiTwotoneExperiment /></div> */}
                                    <div><GiSpartanHelmet /></div>
                                </IconContext.Provider>
                                <span onClick={()=>setOpen(!open)}>Build your Soldier</span>
                            </div>
                        </div>
                        <Snackbar anchorOrigin={{vertical: "buttom",horizontal:"right"}} open={open} autoHideDuration={3000} onClose={()=>setOpen(false)}>
                <Alert onClose={()=>setOpen(false)} severity="info" sx={{ width: '100%' }}>
                    Coming soon!
                </Alert>
            </Snackbar>
                    </div>
                </div>
            </div>
        </section>
    )
}